module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjIwMSIgdmlld0JveD0iMCAwIDMwMSAyMDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjRTMwQTE3IiBkPSJNLjUuNWgzMDB2MjAwSC41eiIvPjxjaXJjbGUgZmlsbD0iI0ZGRiIgY3g9IjEwNi43NSIgY3k9IjEwMC41IiByPSI1MCIvPjxjaXJjbGUgZmlsbD0iI0UzMEExNyIgY3g9IjExOS4yNSIgY3k9IjEwMC41IiByPSI0MCIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0xNDYuMzM0IDEwMC41bDQ1LjIyNSAxNC42OTUtMjcuOTUxLTM4LjQ3MnY0Ny41NTNsMjcuOTUxLTM4LjQ3MXoiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-tr.svg
// module id = +hvJ
// module chunks = 2